module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"register_modal::edit-button":"Редактировать"},"en":{"register_modal::edit-button":"Edit"}}')
  delete Component.options._Ctor
}
